import React, { useEffect, useState } from 'react'
import MiniHeader from '../../components/global/MiniHeader'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
import { useParams, useNavigate } from 'react-router-dom'
import URL from '../../constants/urls'
import { useDispatch } from 'react-redux'
import NoData from '../../components/NoData'

import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { getReceipts } from '../../redux/actions/ReceiptsAction'
import Loader from '../../global/Loader'
import InfiniteScroll from 'react-infinite-scroll-component'
import Receipt from './Receipt'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { errorMessage } from '../../constants/errorMessage'



function ReceiptList(props) {

    const {loader} = props
    const [receiptData, setReceiptData] = useState(EMPTY_ARRAY)
    const [activeReceipt, setActiveReceipt] = useState(EMPTY_ARRAY)
    const [inactiveReceipt, setInActiveReceipt] = useState(EMPTY_ARRAY)
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    let { partner } = useParams()



    useEffect(() => {
        
        getAllReceipts()

    },[EMPTY_ARRAY])

const getAllReceipts = () => {
    setIsLoading(true)
    dispatch(getReceipts(page)).then((res) => {
        if (res?.status == 200 || res?.status == 201) {
            setIsLoading(false)
            let receipts 
            setPage(page+1)
            const data = res?.data?.data
            receipts = [...receiptData, ...data]
            setReceiptData(receipts)
        }else{
            setIsLoading(false)
        }
    }).catch((err) => {
        setIsLoading(false)
        let errObject = { 
            payload: page,
            error: err,
            errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
        }
        dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} getReceipts-ReceiptList.js-41`))
    })
}
const handleDetails  = (item) =>{
    localStorage.removeItem('paymentRecipt')
    localStorage.setItem('paymentRecipt', JSON.stringify(item))

    if(item?.is_expired){
        navigate(`/${partner}${URL?.RECEIPT_DETAIL}/${item?.ticket_number}`)
    }else{
        navigate(`/${partner}${URL?.CONFIRMATION}/${item?.ticket_number}`)
    }
}

    useEffect(() => {
        let active = []
        let inactive = []

        receiptData.map((val) => {
            if (val?.is_expired)
                inactive.push(val)
            else
                active.push(val)
        })
        setActiveReceipt(active)
        setInActiveReceipt(inactive)

    }, [receiptData])


    return (
        <div className='Pave'>
            <MiniHeader title={'RECEIPTS'} isDisplayBack/>
             
            {(loader && receiptData.length < 1) ? <div className='d-flex align-items-center justify-content-center vh-70'><Loader /></div>  : (receiptData && receiptData.length) > 0 ?
                <div>
                    
                    <InfiniteScroll
                        dataLength={receiptData.length}
                        next={() => getAllReceipts(page)}
                        hasMore={true}
                        loader={isLoading && <Loader hideMargin/>}
                        >
                        {(activeReceipt && activeReceipt.length > 0) && <div>
                        <div className='bg-second h-100 pb-2 pt-1'><span className='small text-primary  ms-3 mt-2'>Active Parking Sessions</span></div>
                        <div className='card border-0'>
                            <ul className='list-group ms-2 me-2'>
                                {activeReceipt && activeReceipt.map((value, index) => {
                                    return (
                                        <Receipt handleDetails={handleDetails} receipt={value} key={index}/>
                                    )
                                })

                                }

                            </ul>
                        </div>
                    </div>
                    }
                    {(inactiveReceipt && inactiveReceipt.length > 0) && <div>
                        <div className='bg-second h-100 pb-2 pt-1'><span className='small text-primary  ms-3 mt-2'>Past Parking Sessions</span></div>
                        <div className='card border-0'>
                            <ul className='list-group ms-2 me-2'>
                                {inactiveReceipt && inactiveReceipt.map((value, index) => {
                                    return (
                                        <Receipt handleDetails={handleDetails} receipt={value} key={index}/>
                                    )
                                })

                                }

                            </ul>
                        </div>
                    </div>}
                    </InfiniteScroll>
                </div>
                

                : <NoData message={'No Data Found.'} />}
        </div>
    )
}

ReceiptList.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
}

ReceiptList.defaulProps = {
    dispatch: noop,
    loader: true,
    notify: noop,
}

function mapStateToProps({ ReceiptsReducer }) {
    return {
        loader: ReceiptsReducer?.loader
    }
}
export default connect(mapStateToProps)(ReceiptList)